import { Component, Input } from '@angular/core';

/**
 * Supporting Education Group brand lockup shown at the top of every login-family
 * screen. Single source of truth for the pre-authentication logo so the tenant
 * specific artwork can never drift back in.
 */
@Component({
  selector: 'app-login-brand',
  templateUrl: './login-brand.component.html',
  styleUrls: ['./login-brand.component.css'],
  standalone: false
})
export class LoginBrandComponent {
  /** Strapline under the lockup. Pass an empty string to hide it. */
  @Input() title: string = 'Tuition Management';
}
